import { classNames } from 'libs/react';
import { useLayoutEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { React } from 'libs/react';
import './FormFieldError.scss';
/**
 * @component FormFieldError
 * @since 1.0.0
 */
export function FormFieldError(props) {
    const { style, error } = Object.assign({ style: 'normal' }, props);
    const element = useRef(null);
    const content = useRef(null);
    useLayoutEffect(() => {
        if (element.current == null || content.current == null) {
            return;
        }
        element.current.style.height =
            content.current.getBoundingClientRect().height + 'px';
        element.current.style.opacity = '1';
    }, [error]);
    if (error == null || error == '') {
        return null;
    }
    const className = classNames('form-field-error', 'form-field-error--' + style, props.className);
    return (React.createElement("div", { ref: element, className: className },
        React.createElement("div", { ref: content, className: "form-field-error-body" }, error)));
}
